import React, { useState } from "react";
import api from "../api/axios";
import { useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm";

function AdminLogin() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleAdminLogin = async ({ email, password }) => {
    setLoading(true);
    setMessage("");

    try {
      const res = await api.post(
        `/api/auth/login`,
        { email, password }
      );

      if (!res.data.token) {
        setMessage("トークンが取得できませんでした");
        return;
      }

      localStorage.setItem("adminToken", res.data.token);

      setMessage("ログイン成功。リダイレクトします...");
      navigate("/admin/users");
    } catch (err) {
      console.error(err);
      if (err.response) {
        setMessage(err.response.data?.message || "ログインに失敗しました");
      } else {
        setMessage("通信エラーが発生しました");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: "0 auto", padding: 20 }}>
      <LoginForm title="管理者ログイン" onSubmit={handleAdminLogin} />
      {message && <p style={{ marginTop: 10, color: "red" }}>{message}</p>}
      {loading && <p>ログイン中...</p>}
    </div>
  );
}

export default AdminLogin;